export default {
  continue: {
    id: 'dashboard_diagnosis_continue',
    defaultMessage: 'Continue',
  },
}
